import { ApiProvider } from '@/provider/ApiProvider';

export const fetchBenchmarkGroups = async (filters: BenchmarkGroupParams, signal?: AbortSignal) => {
  const localStorageHeaderBrand = localStorage.getItem('brand_id');
  let mainBrandId = filters.headerBrand || '';
  if (localStorageHeaderBrand && !mainBrandId) {
    mainBrandId = localStorageHeaderBrand;
  }

  const params = new URLSearchParams({
    page_type: filters.pageType || '',
    ...(filters.brandBenchmarkGroupsId
      ? { brand_benchmark_groups_id: String(filters.brandBenchmarkGroupsId) }
      : ''),
    property_id: filters.propertyId ? String(filters.propertyId) : '',
    from_date: filters.fromDate || '',
    to_date: filters.toDate || '',
    header_brand: mainBrandId,
  });
  if (filters.type) {
    params.append('type', filters.type);
  }
  if (filters.brandIds) {
    filters.brandIds.forEach((brandId) => {
      params.append('brand_id[]', String(brandId));
    });
  }

  return ApiProvider.webserviceGet('Brands/GetBenchmarkGroup', params, signal);
};

type BenchmarkGroupParams = {
  propertyId?: number;
  brandIds?: number[];
  pageType?: 'insight';
  type?: 'brand' | 'property';
  brandBenchmarkGroupsId?: number;
  fromDate?: string;
  toDate?: string;
  headerBrand?: string;
};
